import { PostProcesarExcel } from "../../../reducers/comisionCoordinadorAdministrativo";

export interface GeneracionCoordinadorAdministrativoStore
  extends PostProcesarExcel {}

export const generacionCoordinadorAdministrativoStore: (
  state
) => GeneracionCoordinadorAdministrativoStore = state => {
  const comisionCoordinadorAdministrativoState =
    state.comisionCoordinadorAdministrativo;

  return {
    calificaciones: comisionCoordinadorAdministrativoState.calificaciones,
    postingProcesarExcel:
      comisionCoordinadorAdministrativoState.postingProcesarExcel,
    postingProcesarExcelError:
      comisionCoordinadorAdministrativoState.postingProcesarExcelError
  };
};
